import { render, staticRenderFns } from "./FormComprador.vue?vue&type=template&id=b57e59e0&scoped=true"
import script from "./FormComprador.vue?vue&type=script&lang=js"
export * from "./FormComprador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57e59e0",
  null
  
)

export default component.exports